import { OpenArchiveExportEntityConfig }  from '@app/modules/archiving/presets/open-archive-export/open-archive-export-entity-config.model';
import { IOpenArchiveExportEntityEvents } from '@core/interfaces/entity.interface';
import { EntityActionEventEnum }          from '@models/entity.model';

// ENUMS #############################################################
// API enums *********************************************************
export enum OpenArchiveExportStatusEnum {
	CANCELLED = 'cancelled',
	COLLECTING = 'collecting',
	DELETED = 'deleted',
	ERROR = 'error',
	GENERATING = 'generating',
	PENDING = 'pending',
	READY = 'ready'
}

// UI enums *********************************************************
export enum OpenArchiveExportPresetEnum {
	BUSINESS_PREMISES_DETAIL_ARCHIVING_OPEN_ARCHIVE_EXPORT = 'businessPremisesDetailArchivingOpenArchiveExport',
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IOpenArchiveExportEntityActionEvent {
	openArchiveExport: OpenArchiveExport;

	action: EntityActionEventEnum;

	openArchiveExportEntityConfig?: OpenArchiveExportEntityConfig;
}

// TYPES ############################################################
export type OpenArchiveExportProps = ( keyof OpenArchiveExport )[];

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class OpenArchiveExportTMO {
	public businessPremisesId?: string = undefined;

	public created?: Date = undefined;

	public createdBy?: string = undefined;

	public expiration?: Date = undefined;

	public extendable?: boolean = undefined;

	public filesize?: number = undefined;

	public id?: string = undefined;

	public lastModified?: Date = undefined;

	public lastModifiedBy?: string = undefined;

	public result?: OpenArchiveExportResult = undefined;

	public status?: OpenArchiveExportStatusEnum = undefined;
}

export class OpenArchiveExportResultTMO {
	public url?: string = undefined;
}

export class OpenArchiveExportCreateBodyTMO {
	public businessPremisesId: string = undefined;
	public createdDateRange?: OpenArchiveExportCreateDateRange = new OpenArchiveExportCreateDateRange();
	public keywordIds?: string[] = undefined;
	public openArchiveIds?: string[] = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class OpenArchiveExport extends OpenArchiveExportTMO {
	public ui?: IOpenArchiveExportEntityEvents = {};
}

export class OpenArchiveExportResult extends OpenArchiveExportResultTMO {}

export class OpenArchiveExportCreate extends OpenArchiveExportCreateBodyTMO {}

export class OpenArchiveExportCreateDateRange {
	public from: Date = undefined;
	public to: Date = undefined;
}
